import FullProfileModalBase from "./FullProfileModalBase";
import React, {Fragment} from "react";
import GoalMap from "../../../../ui/canvases/GoalMap";
import '../../../../../assets/sass/pages/full-profile/tabs/modals/short-passes-modal.scss';
import ArrowIndicator from "./components/ArrowIndicator";

const passes = [
    {
        from: {x: -400, y: 300},
        to: {x: -100, y: 450}
    }, {
        from: {x: -375, y: 275},
        to: {x: -100, y: 300}
    }, {
        from: {x: 0, y: 150},
        to: {x: 50, y: 300}
    }, {
        from: {x: 150, y: 280},
        to: {x: 250, y: 200}
    }, {
        from: {x: 200, y: 10},
        to: {x: 130, y: 200}
    }, {
        from: {x: -350, y: -80},
        to: {x: -100, y: 100}
    }, {
        from: {x: -300, y: -80},
        to: {x: -80, y: -20}
    }, {
        from: {x: 20, y: -230},
        to: {x: 0, y: -30}
    }, {
        from: {x: -400, y: -80},
        to: {x: -200, y: -300}
    },
];




class ShortPassesModal extends FullProfileModalBase {

    /**
     * Render the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return (
            <Fragment>
                {this.renderArrowIndicator()}
                {this.renderGoalMaps()}
            </Fragment>
        );
    };

    /**
     * Renders definitions of arrows in goal maps.
     * @return {React.ReactNode} The arrows definitions.
     */
    renderArrowIndicator = () => {
        return (
            <div className="indicators">
                <ShortPassesModal.ArrowIndicator color={"#2B82F7"} text={"Accurate Passes"}/>
                <ShortPassesModal.ArrowIndicator color={"#F96274"} text={"Inaccurate Passes"}/>
            </div>
        );
    };

    /**
     * Renders the goals map.
     * @return {React.ReactNode} The goal maps component.
     */
    renderGoalMaps = () => {
        return (
            <div className="goal-map-container">
                <div className="">
                    <div className="title"> First Half</div>
                    <GoalMap passes={passes}/>
                </div>
                <div className="">
                    <div className="title"> Second Half</div>
                    <GoalMap passes={passes}/>
                </div>
            </div>
        );
    };

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "md";

    /**
     * Returns classname of modal.
     * @returns {string} The classname modal.
     */
    modalClassname = () => "short-passes-modal";

    static defaultProps = {
        headerTitle: "Short Passes",
        headerSubtitle: "20 of 20 | 100% Accuracy",
    };
}

ShortPassesModal.ArrowIndicator = ArrowIndicator;

export default ShortPassesModal;
